/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import Pagination from "../../../../Helper/Pagination";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import defaultImg from "../../../../assets/img/thumbnail.png";
import { Switch } from "@mui/material";

export default function GiftVouchers() {
  const [GiftVoucherlist, setGiftVoucherlist] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [loading, setLoading] = useState(true);
  const [selectedState, setselectedState] = useState("");
  const [Image, setImage] = useState("");
  const [ImgPath, setLocalImgPath] = useState("");
  const [price, setprice] = useState("");
  const [description, setdescription] = useState("");
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [name, setname] = useState("");

  const getGiftList = () => {
    setLoading(true);
    GetService(`${API_URL.GIFT_VOUCHERS}?search_key=${search_key}`).then((res) => {
      if (res?.data?.status === true) {
        setGiftVoucherlist(res?.data?.data);
        SetTotalPageCount(res?.data?.totalPages);
        SetTotalCount(res?.data?.totalItems);
        // setCount(res?.data?.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  const onimageUpload = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setLocalImgPath(window.URL.createObjectURL(e.target.files[0]));
    }
  };
  useEffect(() => {
    setprice(selectedState?.price);
    setdescription(selectedState?.description);
    setname(selectedState?.name);
    setLocalImgPath(selectedState?.image);
    setImage(selectedState?.image);
    setsubmitLoader(false);
  }, [selectedState]);

  function resetFunc() {
    setselectedState("");
    setImage("");
    setname("");
    setprice("");
    setdescription("");
    setLocalImgPath(defaultImg);
    setError(false);
    setsubmitLoader(false);
  }
  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };
  useEffect(() => {
    getGiftList();
  }, [search_key, currentPage]);

  function deletecard(id, name) {
    const data = {
      id: id,
      modelName: "gift_cards_model",
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.PERMANENT_DELETE, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getGiftList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  const submit = (e) => {
    e.preventDefault();
    if (!name || !Image) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    const formdata = new FormData();
    formdata.append("name", name);
    if (selectedState?.id) {
      formdata.append("id", selectedState?.id);
    }
    formdata.append("status", "Active");
    formdata.append("image", Image);
    formdata.append("description", description);
    formdata.append("price", price);
    const route = selectedState?.id
      ? API_URL.UPDATE_GIFT_CARDS
      : API_URL.ADD_GIFT_CARDS;
    PostFormData(route, formdata).then(
      (res) => {
        setsubmitLoader(false);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getGiftList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (ID, status) => {
    const data = {
      id: ID,
      status: status === "Active" ? "Inactive" : "Active",
    };

    PostService(API_URL.UPDATE_GIFT_CARDS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getGiftList);
        } else {
          showErrorAlert(res.data?.message, getGiftList);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message, getGiftList);
      }
    );
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Gift Cards</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Gift Cards</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        <div class="card-body">
          <div className="align-items-center d-flex justify-content-end row">
            <div className="col-md-8 p-0">
              <div className="ml-4">
                <button
                  className="btn btn-primary py-2"
                  data-toggle="modal"
                  data-target="#EditModal"
                >
                  Add Gift Card
                </button>
              </div>
            </div>
            <div className="col-md-4 p-0">
              <nav className="navbar">
                <input
                  type="text"
                  name="firstnamesearch"
                  placeholder="Search by Card Name"
                  className="form-control"
                  autoComplete="off"
                  onChange={(e) => {
                    setTimeout(() => {
                      setsearch_key(e.target.value);
                      setCurrentPage(0);
                    }, 400);
                  }}
                />
              </nav>
            </div>
          </div>
          {/* <h4 class="card-title">Image Listing</h4> */}

          <div class="table-responsive mt-3">
            <table class="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Image</th>
                  <th>Card Name</th>
                  <th>Price ($)</th>
                  <th>Discription</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {GiftVoucherlist?.map((item, i) => (
                  <tr key={i}>
                    <td>{i + S_No_Count + 1}</td>
                    <td>
                      <img
                        src={item?.image}
                        alt=""
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                    </td>
                    <td>{item?.name}</td>
                    <td>{item?.price}</td>
                    <td style={{ whiteSpace: "break-spaces" , lineHeight:'1.2'}}>
                      {item?.description}
                    </td>
                    <td>
                      <label
                        className={
                          item?.status === "Active"
                            ? "badge badge-success"
                            : item?.status === "used"
                            ? "badge badge-warning"
                            : "badge badge-danger"
                        }
                      >
                        {item?.status || "Active"}
                      </label>
                    </td>
                    <td>
                      <span className="toggle-switch">
                        <Switch
                          checked={item?.status === "Active"}
                          onChange={() => {
                            changeStatus(item.id, item.status);
                          }}
                          size="small"
                          color="primary" // You can customize the color
                          inputProps={{
                            "aria-label": "toggle switch",
                          }}
                        />
                      </span>

                      <span
                        title="Edit"
                        style={{ cursor: "pointer" }}
                        className="mx-2"
                        data-toggle="modal"
                        data-target="#EditModal"
                        onClick={() => {
                          setselectedState(item);
                        }}
                      >
                        <i className="text-dark fas fa-pen"></i>{" "}
                      </span>

                      <span
                        title="Delete"
                        style={{ cursor: "pointer" }}
                        className="mx-2"
                        // data-toggle="modal"
                        // data-target="#DeleteModal"
                        onClick={() => {
                          deletecard(item?.id, "GiftCard");
                        }}
                      >
                        <i className="text-danger fas fa-trash"></i>{" "}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              {GiftVoucherlist && GiftVoucherlist?.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center">
                    <h6 className="p-3"> No Data Found </h6>
                  </td>
                </tr>
              )}
            </table>
            {loading ? (
              <div className="LoaderSpinner">
                <MoonLoader
                  color={"#003bff"}
                  loading={loading}
                  speedMultiplier={0.6}
                  size={50}
                />
                <div>Loading... Please wait.</div>
              </div>
            ) : (
              ""
            )}
            <div className="mt-4">
              <Pagination
                counting={S_No_Count}
                totaldata={TotalCount}
                pagecount={TotalPageCount}
                onChangePage={handlePageClick}
                activePage={currentPage}
              />
            </div>
          </div>
        </div>
      </div>
      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit GiftCard
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={name}
                    className="form-control"
                    onChange={(e) => setname(e.target.value)}
                    placeholder="name"
                  />
                  {error && !name && (
                    <div className="error">Name cannot be empty</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Price</label>
                  <input
                    type="text"
                    name="name"
                    value={price}
                    className="form-control"
                    onChange={(e) => setprice(e.target.value)}
                    placeholder="price"
                  />
                  {error && !price && (
                    <div className="error">price cannot be empty</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    type="text"
                    name="name"
                    value={description}
                    className="form-control"
                    onChange={(e) => setdescription(e.target.value)}
                    placeholder="description"
                  ></textarea>

                  {error && !description && (
                    <div className="error">Description cannot be empty</div>
                  )}
                </div>
                <div className="mt-3">
                  <div className="row d-flex align-items-start">
                    <div className="col-md-5 col-6">
                      <span>
                        <span className="btn btn-primary col-12">
                          Select Image
                          <input
                            type="file"
                            name="image"
                            accept=".jpg,.jpeg,.png"
                            className="btn-input position-absolute"
                            style={{ opacity: 0 }}
                            onChange={(e) => onimageUpload(e)}
                          />
                        </span>
                      </span>

                      {error && !Image && (
                        <div className="error mt-1">Image is required</div>
                      )}
                    </div>
                    <div className="col-md-7 col-12">
                      <img
                        src={ImgPath ? ImgPath : ""}
                        alt="..."
                        className="CommonImage"
                        onError={(e) => {
                          e.target.src = defaultImg;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
